// Coordonnées légales de l'exploitant du service Oresto.
// Ces informations apparaissent dans les CGV, la politique de confidentialité,
// le registre des traitements et les mentions légales.

export const COMPANY = {
  legalName: "Oresto Sàrl",
  legalForm: "Société à responsabilité limitée (Sàrl)",
  ide: "CHE-325.026.431",
  registry: "inscrite au registre du commerce du canton du Valais",
  publisherLine: "Oresto Sàrl, CHE-325.026.431, Rue d'Oche 10, 1920 Martigny, inscrite au registre du commerce du canton du Valais",
  address: {
    street: "Rue d'Oche 10",
    zip: "1920",
    city: "Martigny",
    country: "Suisse",
  },
  contactEmail: "contact@oresto.ch",
  dpoEmail: "confidentialite@oresto.ch",
  website: "https://oresto.ch",
  monthlyPrice: "129 CHF",
  yearlyPrice: "1'290 CHF",
  trialDays: 7,
  jurisdiction: "Tribunaux du canton du Valais, Suisse",
  lastUpdated: "20 octobre 2026",
  vatNote: "Oresto Sàrl n'est pas assujettie à la TVA. Les prix indiqués sont des montants nets, sans TVA.",
};
